import styled from "styled-components";

export const MobileGrid = styled.div<{ columns?: number }>`
    display: grid;
    grid-template-columns: repeat(${({ columns }) => columns || 1}, 1fr);
    gap: 12px;
    padding: 0 4px;
`;
